<!-- eslint-disable vue/no-multiple-template-root -->
 <!--Designed & Developed by:
    Nirmal K (@cyberwizard1001)⁶
    Nitin Ravi (@nitinravi)
    Ritwik M (@ritwik-m) &
    Nalinadevi K 
 for the Ministry of Education (MOE) virtual-labs project, Govt. Of India -->

<script>
import AfternoonDecoratorComponent from "@/components/AfternoonDecoratorComponent.vue"
import ClassView from "../components/DecoratorDiagramComponent.vue";
import ClerkView from "../components/ClerkComponent.vue";
import CustomerView from "../components/CustomerComponent.vue";
import HiringVehicle from "@/components/HiringVehicleComponent.vue"
import InstructionsView from "../components/InstructionsViewComponent.vue";
import PeakSeasonDecoratorComponent from "@/components/PeakSeasonDecoratorComponent.vue";
import PersonView from "../components/PersonComponent.vue";
import ReservationSystemView from "../components/ReservationSystemComponent.vue";
import ReservationView from "../components/ReservationComponent.vue";
import TestDriverComponent from "@/components/TestDriverComponent.vue";
import VehicleView from "../components/VehicleComponent.vue";
import VehicleDecoratorView from "../components/VehicleDecoratorComponent.vue";
import WeekendDecoratorComponent from "@/components/WeekendDecoratorComponent.vue";

export default {
  components: {
    AfternoonDecoratorComponent,
    ClassView,
    ClerkView,
    CustomerView,
    HiringVehicle,
    InstructionsView,
    PeakSeasonDecoratorComponent,
    PersonView,
    ReservationSystemView,
    ReservationView,
    TestDriverComponent,
    VehicleView,
    VehicleDecoratorView,
    WeekendDecoratorComponent,

  },
  data() {
    return {
      componentSelect: "InstructionsView",
      weekendDecorator: false,
      vehicleDecorator: false,
      testDriver: false,
      peakSeasonDecorator: false,
      afternoonDecorator: false,
    };
  },
  methods: {

    weekendDecoratorCallback(value) {
      console.log("weekendDecoratorCallback", value);
      this.weekendDecorator = value;
    },

    vehicleDecoratorCallback(value) {
      console.log("vehicleDecoratorCallback", value);
      this.vehicleDecorator = value;
    },

    testDriverCallback(value) {
      console.log("testDriverCallback", value);
      this.testDriver = value;
    },

    peakSeasonDecoratorCallback(value) {
      console.log("peakSeasonDecoratorCallback", value);
      this.peakSeasonDecorator = value;
    },

    afternoonDecoratorCallback(value) {
      console.log("afternoonDecoratorCallback", value);
      this.afternoonDecorator = value;
    },

    instructionsReadCallback(){
      this.componentSelect = 'VehicleDecoratorView'
    }

  },
};
</script>

<template>
  <main class="app">
    <div class="buttons">
      <button @click="componentSelect = 'InstructionsView'"
              :style="componentSelect === 'InstructionsView' ? 'background-color: #55acee' : ''">1. Instructions
      </button>
      <button @click="componentSelect = 'CustomerView'"
              :style="componentSelect === 'CustomerView' ? 'background-color: #55acee' : ''">2. Customer
      </button>
      <button @click="componentSelect = 'ClerkView'"
              :style="componentSelect === 'ClerkView' ? 'background-color: #55acee' : ''">3. Exec
      </button>
      <button @click="componentSelect = 'PersonView'"
              :style="componentSelect === 'PersonView' ? 'background-color: #55acee' : ''">4. Person
      </button>
      <button @click="componentSelect = 'VehicleView'"
              :style="componentSelect === 'VehicleView' ? 'background-color: #55acee' : ''">5. Vehicle
      </button>
      <button @click="componentSelect = 'HiringVehicle'"
              :style="componentSelect === 'HiringVehicle' ? 'background-color: #55acee' : ''">6. Hiring Vehicle
      </button>
      <button @click="componentSelect = 'VehicleDecoratorView'"
              :style="componentSelect === 'VehicleDecoratorView' ? 'background-color: #55acee' : ''">7. Vehicle Decorator
      </button>
      
      <button @click="componentSelect = 'WeekendDecoratorComponent'"
              :disabled="!vehicleDecorator"
              :style="componentSelect === 'WeekendDecoratorComponent' ? 'background-color: #55acee' : ''">8. Weekend Decorator
      </button>
      <button @click="componentSelect = 'AfternoonDecoratorComponent'"
              :disabled="!weekendDecorator"
              :style="componentSelect === 'AfternoonDecoratorComponent' ? 'background-color: #55acee' : ''">9. Afternoon Decorator
      </button>
      <button @click="componentSelect = 'PeakSeasonDecoratorComponent'"
              :disabled="!afternoonDecorator"
              :style="componentSelect === 'PeakSeasonDecoratorComponent' ? 'background-color: #55acee' : ''">10. Peak Season Decorator
      </button>
      <button @click="componentSelect = 'ReservationSystemView'"
              :style="componentSelect === 'ReservationSystemView' ? 'background-color: #55acee' : ''">11. Reservation System
      </button>
      <button @click="componentSelect = 'ReservationView'"
              :style="componentSelect === 'ReservationView' ? 'background-color: #55acee' : ''">12. Reservation
      </button>
      <button @click="componentSelect = 'TestDriverComponent'"
              :disabled="!peakSeasonDecorator"
              :style="componentSelect === 'TestDriverComponent' ? 'background-color: #55acee' : ''">13. Test Driver
      </button>
      <button @click="componentSelect = 'ClassView'"
              :style="componentSelect === 'ClassView' ? 'background-color: #55acee' : ''">14. Class Diagram
      </button>
    </div>

    <KeepAlive>
      <component
          v-bind:is="componentSelect"
          @weekend-decorator="weekendDecoratorCallback"
          @vehicle-decorator="vehicleDecoratorCallback"
          @test-driver="testDriverCallback"
          @peak-season-decorator="peakSeasonDecoratorCallback"
          @afternoon-decorator="afternoonDecoratorCallback"
          @instructions-read="instructionsReadCallback"

      />
    </KeepAlive>
  </main>
  <!--eslint-disable-next-line vue/no-multiple-template-root-->
  <footer v-show="weekendDecorator && vehicleDecorator && testDriver && peakSeasonDecorator && afternoonDecorator">
    <div id="buttons" class="relative">
      <button class="navitem" @click="$router.push('/screen-two')">Next</button>
    </div>
  </footer>
</template>

<style>
.app {
  background-color: #f9fafe;
  min-height: 1024px;
}

button {
  margin-top: 30px;
  border: none;
  padding: 20px;
  margin-left: 5px;
  background-color: #2c3e50;
  color: white;
  width: 500px;
}

button:first-of-type {
  margin-left: 30px;
}

.buttons {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  margin-top: 0;
}

button:disabled {
  background-color: #7c8e9d;
}

</style>
 